module.exports = __webpack_public_path__ + "static/media/aceptable-marker.e9bc0652.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/aceptable-marker.svg
// module id = 870
// module chunks = 0